"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = function useStyles(_ref) {
  var width = _ref.width;
  return (0, _styles.makeStyles)(function (theme) {
    return {
      menuPaper: {
        boxShadow: theme.shadows[2],
        marginTop: theme.spacing(0.75)
      },
      customWidth: {
        width: width
      },
      menuList: {
        boxShadow: theme.shadows[2]
      },
      menuItem: {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(20),
        color: theme.palette.NEUTRAL500,
        padding: theme.spacing(1.25, 2),
        '&:hover': {
          backgroundColor: theme.palette.BLUE050
        },
        '&.selected': {
          color: theme.palette.BLUE400,
          fontWeight: theme.typography.fontWeightMedium
        }
      }
    };
  })();
};
var _default = useStyles;
exports.default = _default;